module.exports = __webpack_public_path__ + "img/banner.878bd395.png";